<template>
    <div class="custom_modal_wrap">
        <div class='d-flex justify-content-between align-items-center neue mb16'>
            <Icon v-if="this.$store.state.resize.w <= 768" :name="'arrow-left'" class="pointer" @click="this.close" />
            <h4 class="mb-0 text-black neue fw-medium lh28 fsp20 pr24" :class="{ 'flex-grow-1 text-center': this.$store.state.resize.w <= 768 }">{{ this.$store.state.modal.content.title }}</h4>
            <Icon v-if="this.$store.state.resize.w > 768" @click='this.close' :name="'close'" class="pointer"  />
        </div>
        <div class="bg-white rounded w608" :class="{ 'pp-24': this.$store.state.resize.w > 768 }">
            <div v-if="this.content" class="border-full bg-light-grey p24 rounded mb40">
                <div class="d-flex flex-row align-items-center mh-52 col-8 pbp-16 w-100 border-bottom mbp-16">
                    <div v-if="content.image" class="item-i round-border contain c40" :class="{'mrp-10': this.mobile, 'mrp-12': !this.mobile}" :style="`background-image: url('${content.image}');`"></div>
                    <div v-else :class="{'mrp-10': this.mobile, 'mrp-12': !this.mobile}">
                        <Icon name="default-curr" size="c40" />
                    </div> 
                    <div class="d-flex flex-column flex-grow-1">
                        <div class="d-flex align-items-center justify-content-between flex-grow-1">
                            <div>
                                <div class='neue-roman d-flex align-items-center flex-row'>
                                    <span v-if='content.identifier' :title='content.identifier' class="d-block text-black neue fw-medium text-truncate">
                                        {{ this.$store.state.resize.w < 768 ? sbstring(content.identifier) : content.identifier }}
                                    </span>
                                    <span v-else :title='content.code' class="text-black neue fw-medium text-truncate">{{ content.code }}</span>
                                </div>
                                <span class='primary-grey light fsp14' :class="{'fsp12': this.mobile}" :title='content.name'>{{ content.name }}</span>
                            </div>
                            <div>
                                <Button 
                                    v-if="this.$store.state.resize.w > 768"
                                    @mouseover="hovered = 'copy'"
                                    @mouseleave="hovered = false"
                                    @click.stop="copy(content.identifier || content.code)" :name="''"
                                    class="flex-grow-1 primary-grey h40 w40" type='btn-outline-grey stroke'
                                >
                                    <Icon :name="'copy'" is_сolored class="pointer cli_2 c20" :active="hovered != 'copy'" />
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-between align-items-center">
                    <div class="primary-grey" :class="{ 'mb16': this.$store.state.resize.w > 768 }">{{ $t('components.service.modal.AssetDetails.3') }}</div>
                    <div v-if="content.explorer_link && this.$store.state.resize.w > 768" class="d-flex align-items-center">
                        <a :href="content.explorer_link" target="_blank" class="main-color w186 text-truncate main-color neue fw-medium text-decoration-underline">{{ content.explorer_link }}</a>
                        <Icon :name="'external-link'" class="item-i mlp-4 c18" />
                    </div>
                    <div v-if="this.$store.state.resize.w <= 768" class="neue fw-medium text-black"><span v-html="this.sumMask(this.$lib.precRound(this, content.balance_copy, content.precision || 2))"></span> <span class="primary-grey">{{ content.curr }}</span></div>
                </div>
                <div v-if="this.$store.state.resize.w > 768" class="fsp32 neue fw-medium text-black lh40 mb6">{{ this.$lib.precRound(this, content.balance_copy, content.precision || 2) }} <span class="primary-grey fsp20">{{ content.curr }}</span></div>
                <div v-if="content.rate && content.rate !== ''">
                    <span v-html='this.sumMask(this.convertByRate())'></span>&nbsp;
                    <span class="primary-grey">{{ this.$store.state.config.KEYTS_RATE_CURR_TEXT }}</span>
                </div>
            </div>
            <div v-if="this.content" class="text-black fsp20 mbp-16">{{ this.act === 'payOut' ? $t('components.service.modal.PaySelect.31') : $t('components.service.modal.PaySelect.32') }}</div>
            <div class='container-fluid methods mt-1 p-0 g-3 align-items-stretch gap20'>
                <div v-for="(item, index) in this.actions[this.act]['list']"
                    :key="index" 
                    v-on:mouseover="this.hovered = index"
                    v-on:mouseleave="this.hovered = false"
                    v-on:click="() => {item.handler(); this.close()}"
                    class="card"
                    :class="{ 'p16': this.$store.state.resize.w <= 768, 'px16 py24': this.$store.state.resize.w > 768 }"
                >
                    <div class="h100 d-flex flex-column align-items-center justify-content-center text-center">
                        <Icon :name="item.icon" :size="this.$store.state.resize.w > 768 ? 'c60' : 'c40'" :stroke_width="'1.5'" :preset="true" class="mb12" :active="true" />
                        <span class="neue fw-bold" :class="{ 'fsp12 lh16': this.$store.state.resize.w <= 768, 'fsp14 lh20': this.$store.state.resize.w > 768 }">
                            {{ item.name }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Icon from "@/components/icons/Icon.vue"; 
import Button from "../Button.vue";

export default {
    props: {
        close: [Function],
    }, 
    components: {
        Icon,
        Button
    },
    data () {
        return {
            content: this.$store.state.modal.content.keyt?.curr ? this.$store.state.modal.content.keyt.curr : this.$store.state.modal.content.keyt,
            act: this.$store.state.modal.content.action, 
            curr: this.$store.state.modal.content.curr,
            hovered: false,
            actions: {
                payIn: {
                    title: this.$t('components.service.modal.PaySelect.1'),
                    list: [
                        {
                            name: this.$t('components.service.modal.PaySelect.2'),
                            desc: this.$t('components.service.modal.PaySelect.18'),
                            handler: () => {
                                if(this.content) {
                                    let params = {
                                        keyt: this.content.code,
                                    };
                                    this.$router.push({name: 'Payin', query: params})
                                } else {
                                    this.$router.push({name: 'Payin'})
                                }
                            },
                            icon: 'cryptocurr-new'
                        },
                        {
                            name: this.$t('components.service.modal.PaySelect.11'),
                            desc: this.$t('components.service.modal.PaySelect.19'),
                            handler: () => {
                                const query = {};
                                if(this.curr) {
                                   query.curr_recive = this.curr.value;
                                   query.code = this.curr.curr_code
                                } else {
                                    query.curr_recive = this.content.curr_name;
                                    query.code = this.content.curr_code
                                }
                                this.$router.push({ name: 'p2p_offers', query })
                            },
                            icon: 'p2p-new'
                        },
                        {
                            name: this.$t('components.service.modal.PaySelect.5'),
                            desc: this.$t('components.service.modal.PaySelect.20'),
                            handler: () => {
                                if(this.content) {
                                    let params = {
                                        keyt: this.content.code,
                                    };
                                    this.$router.push({name: 'CreateEcheck', query: params})
                                } else {
                                    this.$router.push({name: 'CreateEcheck'})
                                }
                            },
                            icon: 'echeck-new'
                        },
                        {
                            name: this.$t('components.service.modal.PaySelect.12'),
                            desc: this.$t('components.service.modal.PaySelect.21'),
                            handler: () => {
                                let params = {
                                    stage: 0
                                };
                                this.$router.push({name: 'Templates', query: params})
                            },
                            icon: 'template-new'
                        },
                    ]
                },
                payOut: {
                    title: this.$t('components.service.modal.PaySelect.7'),
                    list: [
                        {
                            name: this.$t('components.service.modal.PaySelect.9'),
                            desc: this.$t('components.service.modal.PaySelect.23'),
                            handler: () => {
                                this.$router.push({name: 'Pay'})
                            },
                            icon: 'pay-new'
                        },
                        {
                            name: this.$t('components.service.modal.PaySelect.10'),
                            desc: this.$t('components.service.modal.PaySelect.24'),
                            handler: () => {
                                this.$router.push('/masspayment/new')
                            },
                            icon: 'masspay-new'
                        },
                        {
                            name: this.$t('components.service.modal.PaySelect.11'),
                            desc: this.$t('components.service.modal.PaySelect.25'),
                            handler: () => {
                                const query = {};
                                if(this.curr) {
                                   query.curr_give = this.curr.value;
                                   query.code = this.curr.curr_code
                                } else {
                                    query.curr_give = this.content.curr_name;
                                    query.code = this.content.curr_code
                                }
                                this.$router.push({ name: 'p2p_offers', query })
                            },
                            icon: 'p2p-new'
                        },
                        {
                            name: this.$t('components.service.modal.PaySelect.12'),
                            desc: this.$t('components.service.modal.PaySelect.26'),
                            handler: () => {
                                let params = {
                                    stage: 2
                                };
                                this.$router.push({name: 'Templates', query: params})
                            },
                            icon: 'template-new'
                        },
                    ]
                },
                transfer: {
                    title: this.$t('components.service.modal.PaySelect.13'),
                    list: [
                        {
                            name: this.$t('components.service.modal.PaySelect.14'),
                            desc: this.$t('components.service.modal.PaySelect.27'),
                            handler: () => {
                                this.$router.push({name: 'Stock'})
                            },
                            icon: 'exchange'
                        },
                        {
                            name: this.$t('components.service.modal.PaySelect.15'),
                            desc: this.$t('components.service.modal.PaySelect.28'),
                            handler: () => {
                                this.$router.push({name: 'Transfer_id'})
                            },
                            icon: 'user'
                        },
                        {
                            name: this.$t('components.service.modal.PaySelect.16'),
                            desc: this.$t('components.service.modal.PaySelect.29'),
                            handler: () => {
                                if(this.content) {
                                    let params = {
                                        keyt: this.content.code,
                                    };
                                    this.$router.push({name: 'Transfer_self', query: params})
                                } else {
                                    this.$router.push({name: 'Transfer_self'})
                                }
                            },
                            icon: 'horizontal_arr'
                        },
                        {
                            name: this.$t('components.service.modal.PaySelect.17'),
                            desc: this.$t('components.service.modal.PaySelect.30'),
                            handler: () => {
                                let params = {
                                    stage: 1
                                };
                                this.$router.push({name: 'Templates', query: params})
                            },
                            icon: 'template'
                        },
                    ]
                },
            }
        }
    },
    computed: {
        mobile () {
            return this.$store.state.isMobile;
        }
    },
    methods: {
        copy(text) {
            this.$lib.copyTextS(text, this.$store)
        },
        back() {
            this.$store.commit('MODAL', {
                action: true,
                type: 'AssetDetails',
                content: {
                    title: this.$t('views.Keyts.List.48'),
                    body: this.$store.state.modal.content.keyt,
                    callbackDelete: this.$store.state.modal.content.callbackDelete,
                    callbackRename: this.$store.state.modal.content.callbackRename,
                    callbackHide: this.$store.state.modal.content.callbackHide,
                    width: 608
                },
            });
        },
        sumMask(sum, isSameSize) {
            if (!sum) {
                return;
            }
            let classList = `${this.mobile ? 'fsp20' : ''} text-black`
            if(isSameSize) {
                classList = 'fsp16'
            }
            let arr = sum.split('.');
            if (arr[1]) {
                return `<span  class='${classList}'>${arr[0].replace(/(\d)(?=(\d\d\d)+\b)/ig, '$1  ')}</span><span class='neue fw-medium fsp12 primary-grey'>.${arr[1]}</span>`
            } else {
                return `<span  class='${classList}'>${arr[0].replace(/(\d)(?=(\d\d\d)+\b)/ig, '$1  ')}</span>`
            }
        },
        convertByRate() {
            return this.$lib.precRound(this, this.$lib.ev(this, `${this.content.balance_copy} * ${this.content.rate}`), '2'); 
        },
        sbstring(str) {
            if (this.$store.state.resize.w < 1024 && this.$store.state.resize.w > 768 && str.length > 7) {
                return this.$lib.getTokenString(str, 4);
            } else if(this.$store.state.resize.w <= 768) {
                return this.$lib.getTokenString(str, 12);
            } else if (this.$store.state.resize.w < 1200 && str.length > 12) {
                return this.$lib.getTokenString(str, 8);
            } else if (str.length > 30) {
                return this.$lib.getTokenString(str, 8);
            } 
            return this.$lib.getTokenString(str, 6);
        },
    },
    mounted() {
        console.log('content', this.content);
    }
}
</script>

<style lang="scss" scoped>
.simp-bg {
  background-color: $color-href;
  border: 1px solid $color-href;
  color: white;
  width: 40px;
  height: 40px;
  min-width: 40px;
  border-radius: 50%;
}
.w186 {
    width: 186px;
}
.card {
    border-radius: 15px;
    border: 1px solid $primary-stroke;
    min-height: 128px;
    // width: 245px;
    cursor: pointer;
    // @media (min-width: 1920px) {
        // max-width: 213px;
    // }

}
.methods {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
}
.mob-card:not(:last-child) {
    margin-bottom: 20px;
}
</style>